module.exports = __webpack_public_path__ + "img/document_icon.bed1a055.svg";